







































































































import { Component, Watch } from "vue-property-decorator";
import ConfirmationDialogComponent from "@/components/common/ConfirmationDialog.vue";
import { 
  ProjectManagementSettings,
  DeviceManagerSettings 
} from "@/data/models/Settings";
import { ProjectManagementSettingsModule } from "@/store/modules/ProjectManagementSettingsModule";
import { defineOwnProjectManagementSettingsClientAccess } from "@/permissions/ClientPermissions";
import { createDefaultDeviceManagerSettings } from "@/data/models/Client";
import { updateProjectManagementSettings } from "@/data/repository/SettingsRepository";
import PickerDialogComponent from "@/components/common/PickerDialog.vue";
import SettingsPageMixin from "@/components/settings/SettingsPageMixin";

@Component({
  components: {
    "confirmation-dialog": ConfirmationDialogComponent,
    picker: PickerDialogComponent,
  },
})
export default class DeviceManagerSettingsComponent extends SettingsPageMixin {
  isInitializing = true;

  canUserAddProjects = false;
  canUserAddContactPersons = false;
  canUserAddRooms = false;
  canUserAddDevices = false;
  recentlyCompletedTask = 7;

  initialDeviceManagerSettings: DeviceManagerSettings = createDefaultDeviceManagerSettings();

  yesNoValues = [true, false];

  @Watch("projectManagementSettings")
  onProjectManagementSettingsChanged() {
    const deviceManagerSettings = this.projectManagementSettings.deviceManagerSettings;

    if (
      deviceManagerSettings && 
      !deviceManagerSettings.areDefaultDeviceManagerSettings
    ) {
      this.initializeParameters(deviceManagerSettings);  
    }
  }

  get hasChanged() {
    return (
      this.canUserAddProjects !== this.initialDeviceManagerSettings.canUserAddProjects ||
      this.canUserAddContactPersons !== this.initialDeviceManagerSettings.canUserAddContactPersons ||
      this.canUserAddRooms !== this.initialDeviceManagerSettings.canUserAddRooms ||
      this.canUserAddDevices !== this.initialDeviceManagerSettings.canUserAddDevices ||
      this.recentlyCompletedTask !== this.initialDeviceManagerSettings.recentlyCompletedTask
    );
  }

  get isNotValid() {
    return this.recentlyCompletedTask < 1 || this.recentlyCompletedTask > 30;
  }

  get projectManagementSettings() {
    return ProjectManagementSettingsModule.projectManagementSettings;
  }

  get deviceManagerSettings() {
    return this.projectManagementSettings.deviceManagerSettings;
  }

  get canEdit() {
    return defineOwnProjectManagementSettingsClientAccess();
  }

  get readonly() {
    return !this.isEditMode || !this.canEdit;
  }

  formatYesNo(value: boolean) {
    return this.$t(`common.${value ? "yes" : "no"}`).toString();
  }

  initializeParameters(
    deviceManagerSettings: DeviceManagerSettings,
  ) {
    this.canUserAddProjects = deviceManagerSettings.canUserAddProjects;
    this.canUserAddContactPersons = deviceManagerSettings.canUserAddContactPersons;
    this.canUserAddRooms = deviceManagerSettings.canUserAddRooms;
    this.canUserAddDevices = deviceManagerSettings.canUserAddDevices;
    this.recentlyCompletedTask = deviceManagerSettings.recentlyCompletedTask ?? 7;

    this.initialDeviceManagerSettings = deviceManagerSettings;

    this.isEditMode = false;
  }

  async created() {
    this.isInitializing = true;
    const deviceManagerSettings = this.projectManagementSettings.deviceManagerSettings;

    if (deviceManagerSettings && !deviceManagerSettings.areDefaultDeviceManagerSettings) {
      this.initializeParameters(deviceManagerSettings);
    }
    else {
      const defaultDeviceManagerSettings = createDefaultDeviceManagerSettings();

      this.initializeParameters(defaultDeviceManagerSettings);
    }
    this.isInitializing = false;
  }

  async doSave() {
    const deviceManagerSettingsUpdate: DeviceManagerSettings = {
      canUserAddProjects: this.canUserAddProjects,
      canUserAddContactPersons: this.canUserAddContactPersons,
      canUserAddRooms: this.canUserAddRooms,
      canUserAddDevices: this.canUserAddDevices,
      recentlyCompletedTask: this.recentlyCompletedTask,
      
      areDefaultDeviceManagerSettings: false,
    }

    const update: ProjectManagementSettings = {
      ...this.projectManagementSettings,
      deviceManagerSettings: deviceManagerSettingsUpdate,
    }

    await updateProjectManagementSettings(update);

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.initialDeviceManagerSettings = update.deviceManagerSettings!!;
  }

  mounted() {
    this.setToolbarTitle(this.$t("settings.projectManagement.deviceManagerSettings.title").toString());
  }
}
